const APP_ENV = process.env.APP_ENV || "production"; // local / testing / production

const ENVIRONMENTS = {
  local: {
    apiBaseUrl: "http://localhost:7001",
    frontendBaseUrl: "http://localhost:9090",
  },

  testing: {
    apiBaseUrl: "https://api.testing.potholerepair.com",
    frontendBaseUrl: "https://testing.customers.potholerepair.com",
  },

  production: {
    apiBaseUrl: "https://api.crm.potholerepair.com",
    frontendBaseUrl: "https://customers.potholerepair.com",
  },
};

const currentEnvironment =
  ENVIRONMENTS[APP_ENV] || ENVIRONMENTS.testing;

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  `${currentEnvironment.apiBaseUrl}/api`;

const FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_URL ||
  currentEnvironment.frontendBaseUrl;

const FILES_URL =
  process.env.REACT_APP_FILES_URL ||
  `${currentEnvironment.apiBaseUrl}/uploaded/files`;

const CLIENT_API_DOCS_URL =
  process.env.REACT_APP_CLIENT_API_DOCS_URL ||
  "http://localhost:4200/docs";

module.exports = {
  BACKEND_URL,
  FRONTEND_URL,
  FILES_URL,
  CLIENT_API_DOCS_URL,
  env: APP_ENV,
  apiBaseUrl: currentEnvironment.apiBaseUrl,
};
